interface Bounds {
  top: number;
  bottom: number;
}

// Clips an absolutely-positioned child; `auto` clips whether or not it currently overflows.
const CLIPPING_OVERFLOW = ['auto', 'scroll', 'hidden', 'overlay'];

/** Viewport-relative bounds of the nearest ancestor that clips `node`, or the viewport itself. */
export const getClippingBounds = (node: HTMLElement | null): Bounds => {
  let el = node?.parentElement ?? null;
  while (el) {
    if (CLIPPING_OVERFLOW.includes(getComputedStyle(el).overflowY)) {
      const { top, bottom } = el.getBoundingClientRect();
      return { top, bottom };
    }
    el = el.parentElement;
  }
  return { top: 0, bottom: window.innerHeight };
};
